module.exports = __webpack_public_path__ + "img/bus-7.256fdee9.png";